import dynamic from 'next/dynamic';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import { SidebarItemSectionProps } from './props';
import useSidebarVariant from '@/hooks/theme/variants/useSidebarVariant';
import { PropsWithChildren } from 'react';
const SidebarItemSectionContent = dynamic(() => import('./V1'), {
  ssr: true,
});

export default function SidebarItemSection(
  props: PropsWithChildren<SidebarItemSectionProps>,
): JSX.Element {
  const version: string = useSidebarVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.SidebarV1.toString():
      return <SidebarItemSectionContent {...props} />;
    case SettingLayoutComponentId.SidebarV2.toString():
      return <SidebarItemSectionContent isVariant {...props} />;
    default:
      return <SidebarItemSectionContent {...props} />;
  }
}
